import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import React from 'react';
import classNames from 'classnames';
import TypeCounter from './TypeCounter';
import TreeSummaryRow from './TreeSummaryRow';
const DefaultAssetCounts = ({ assetCounts }) => {
    const { truck, bus, van, trailer, driver } = assetCounts;
    return (_jsxs(_Fragment, { children: [_jsx(TypeCounter, { hideOnZero: true, icon: 'truck-baseline', value: truck }), _jsx(TypeCounter, { hideOnZero: true, icon: 'trailer-baseline', value: trailer }), _jsx(TypeCounter, { hideOnZero: true, icon: 'bus-baseline', value: bus }), _jsx(TypeCounter, { hideOnZero: true, icon: 'van-baseline', value: van }), _jsx(TypeCounter, { hideOnZero: true, icon: 'driver', value: driver })] }));
};
const TreeSummary = React.memo((props) => {
    const { className = '', assetCounts = {}, gridCols, children } = props;
    const classes = classNames('TreeSummary', 'display-flex flex-wrap', 'align-items-center', 'gap-10', 'padding-left-3', className);
    return (_jsx("div", Object.assign({ className: classes }, { children: children || (_jsx(TreeSummaryRow, Object.assign({ gridCols: gridCols }, { children: _jsx(DefaultAssetCounts, { assetCounts: assetCounts }) }))) })));
});
export default TreeSummary;
